<template>
  <Layout style="height: 100%" class="main">
    <Sider hide-trigger collapsible :width="256" :collapsed-width="64" v-model="collapsed" class="left-sider" :style="{overflow: 'hidden'}">
      <div class="logo-con logo-max" v-show="!collapsed">
        <h1>商铺管理系统</h1>
        <img :src="maxLogo" key="max-logo"/>
        <div class="max-info"><label style="margin-right:10px;">{{userrole}}</label><span>{{username}}</span></div>
      </div>
      <div class="logo-con" v-show="collapsed">
        <img :src="minLogo" key="min-logo"/>
      </div>
      <sidebar></sidebar>
    </Sider>
    <Layout>
      <Header class="header-con">
        <header-bar :collapsed="collapsed">
          <Notice :count="noticeCount"/>
          <user :user-avator="minLogo"/>
          <!--<language v-if="$config.useI18n" @on-lang-change="setLocal" style="margin-right: 10px;" :lang="local"/>-->
          <!--<error-store v-if="$config.plugin['error-store'] && $config.plugin['error-store'].showInHeader" :has-read="hasReadErrorPage" :count="errorCount"></error-store>-->
          <!--<fullscreen v-model="isFullscreen" style="margin-right: 10px;"/>-->
        </header-bar>
      </Header>
      <!--<search-shop></search-shop>-->
      <Content class="main-content-con">
        <Layout class="main-layout-con">
          <!--<div class="tag-nav-wrapper">-->
            <!--<tags-nav :value="$route" @input="handleClick" :list="tagNavList" @on-close="handleCloseTag"/>-->
          <!--</div>-->
          <Content class="content-wrapper">
            <router-view/>
          </Content>
        </Layout>
      </Content>
    </Layout>
  </Layout>
</template>
<script>
import sidebar from './components/sidebar'
import SearchShop from './components/search-shop'
import HeaderBar from './components/header-bar'
import User from './components/user'
import Notice from './components/notice'
import ErrorStore from './components/error-store'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { getNewTagList, getNextRoute, routeEqual } from '@/libs/util'
import minLogo from '@/assets/images/logo-min.jpg'
import maxLogo from '@/assets/images/logo.png'
import './main.less'
export default {
  name: 'Main',
  components: {
    SearchShop,
    sidebar,
    HeaderBar,
    ErrorStore,
    User,
    Notice
  },
  data () {
    return {
      collapsed: false,
      minLogo,
      maxLogo,
      noticeCount:0,
      username: '',
      userrole: ''
    }
  },
  computed: {
  },
  methods: {
  },
  watch: {

  },
  created () {
    this.username = sessionStorage.getItem('name');
    this.userrole = sessionStorage.getItem('role');
  }
}
</script>
